/**
 * Fiskal Cloud Selfcare API
 * # Overview  ## TSS pre-initialization Pre-initializes TSS with following options: * creating cloud TSS (with CSP account) for ERS that are not assigned to any TSS * creating cloud TSS (with CSP account) for BP that doesn\'t have any TSS * activation of inactive TSS and creation of CSP account 
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Paging information
 */
export interface PagingDTO { 
    /**
     * Page number, first page is 0
     */
    pageNumber: number;
    /**
     * Number of items in the page
     */
    pageSize: number;
    /**
     * Total number of pages
     */
    pageCount: number;
    /**
     * Total number of elements
     */
    totalElements: number;
}

export class ClsPagingDTO { 
    /**
     * Page number, first page is 0
     */
    pageNumber: number = undefined;
    /**
     * Number of items in the page
     */
    pageSize: number = undefined;
    /**
     * Total number of pages
     */
    pageCount: number = undefined;
    /**
     * Total number of elements
     */
    totalElements: number = undefined;
}

